import React from 'react'
import { Container } from 'reactstrap'
import Contact from '../contact'
import Contactform from '../contact/form'

export default function Footer() {
    return (
        <footer className="footer-main-wrapper" id="contact">
            <Container>
               <div className="footer-wrapper">
                    <Contact />
                  <div className="footer-second-block wow bounceInUp" data-wow-offset="50" data-wow-duration="1s"
                     data-wow-delay="0.10s">
                     <div id="message"></div>
                     <Contactform />
                  </div>
               </div>
            </Container>
            <div className="footer-copytext-wrapper">
               <div className="container">
                  <div className="footer-copy-text">
                     <p>© copyright Esselight Template By Rangzol Themes.</p>
                  </div>
               </div>
            </div>
        </footer>
    )
}